
import React from "react";
import { Classname } from "@rivtn/noseur";
import Btn from "../common/Btn";
import NewsCard from "../common/NewsCard";
import Highlight from "../common/Highlight";
import { i18nManager } from "../../i18n";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { isPageVisible, pagePath } from "../../helpers";
import { ITeamNews, ITeamWebsite, ITournamentEditionMatch } from "../../../../../services";
import { matchParticipants, matchScores, participantImage, participantName } from "../common/match";

function MiniMatch({ publicId, match: t }: { publicId: string; match: ITournamentEditionMatch; }) {

    const labels = i18nManager.Labels.match;
    const scores = matchScores(t);
    const isLive = t.status === "ONGOING";

    return (<a className={styles["mini-match"]} target="_blank" rel="noreferrer" href={Utils.buildTournamentMatchLink(publicId, t)}>
        <div className={styles["mini-match-head"]}>
            <span className={Classname.build(styles["mini-match-date"], { [styles["is-live"]]: isLive })}>{isLive ? (<><i className="fa fa-circle" style={{ fontSize: "0.55em", verticalAlign: "middle" }} /> {labels.live}</>) : Utils.fineDate(new Date(t.start_date))}</span>
            <span className={styles["mini-match-comp"]}><span>{t.tournament_edition?.name}</span></span>
        </div>
        {matchParticipants(t).slice(0, 2).map((p, i) => (<div key={p.external_id + i} className={styles["mini-match-team"]}>
            {participantImage(p) ? (<img src={participantImage(p)} alt="" />) : (<span className={styles["mini-match-ph"]} />)}
            <span className={styles["mini-match-name"]}>{participantName(p)}</span>
            <span className={styles["mini-match-score"]}>{t.status === "UPCOMING" ? "-" : (scores?.[i] ?? "-")}</span>
        </div>))}
    </a>);
}

export interface NewsMatchesProps {
    publicId: string;
    basePath: string;
    news?: ITeamNews[];
    website: ITeamWebsite;
    matches?: ITournamentEditionMatch[];
}

function NewsMatches({ website, basePath, publicId, news, matches }: NewsMatchesProps) {

    const labels = i18nManager.Labels.home;
    const [tab, setTab] = React.useState<"upcoming" | "past">("upcoming");
    const showNews = isPageVisible(website, "NEWS") && !!news?.length;
    const showMatches = !!matches;
    const upcoming = (matches ?? []).filter((m) => m.status !== "ENDED");
    const past = (matches ?? []).filter((m) => m.status === "ENDED").reverse();
    const list = (tab === "upcoming" ? upcoming : past).slice(0, 4);

    if (!showNews && !showMatches) return null;

    return (<section className={Classname.build(styles["section"], styles["bg-ink"])}>
        <div className={styles["container"]}>
            <h2 className={styles["section-title"]}><Highlight text={showNews && showMatches ? labels.news_matches : `:${showNews ? labels.news_title : labels.matches_title}`} /></h2>
            <div className={Classname.build(styles["news-matches"], { [styles["single"]]: !showNews || !showMatches })}>
                {showNews && (<div>
                    <div className={styles["news-matches-grid"]}>
                        {news!.slice(0, 4).map((n) => (<NewsCard key={n.external_id} news={n} to={{ pathname: pagePath(basePath, "NEWS"), search: `article=${n.external_id}` }} />))}
                    </div>
                    <div className={styles["row-foot"]}><Btn variant="text" to={pagePath(basePath, "NEWS")}>{i18nManager.Labels.view_all}</Btn></div>
                </div>)}
                {showMatches && (<div className={styles["matches-widget"]}>
                    <div className={styles["tab-nav"]} role="tablist">
                        {([["upcoming", labels.upcoming], ["past", labels.past_results]] as ["upcoming" | "past", string][]).map(([v, l]) => (
                            <button key={v} role="tab" aria-selected={tab === v} className={Classname.build(styles["tab-nav-item"], { [styles["active"]]: tab === v })} onClick={() => setTab(v)}>{l}</button>
                        ))}
                    </div>
                    {list.length === 0
                        ? (<div className={styles["empty"]}>{labels.no_matches}</div>)
                        : (<div className={styles["mini-matches"]}>{list.map((m) => (<MiniMatch key={m.external_id} match={m} publicId={publicId} />))}</div>)}
                    <div className={styles["row-foot"]}><Btn variant="text" to={pagePath(basePath, "SCHEDULE")}>{labels.full_schedule}</Btn></div>
                </div>)}
            </div>
        </div>
    </section>);
}

export default NewsMatches;
